import Vue from "vue";
const plugin = {
  install(Vue) {
    // 4. add an instance method
    Vue.prototype.$user = {
      statusColor: role => {
        switch (+role) {
          case 1:
            return "orange";
          case 2:
            return "info";
          case 3:
            return "error";
          default:
            return "grey";
        }
      }
    };
  }
};

Vue.use(plugin);
